var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    _vm.$style.wrapper,
    _vm.$style[("variant-" + _vm.variant)]
  ]},[_vm._v("\n  #pick8team\n  "),_c('span',[_vm._v("\n    "+_vm._s(_vm.$t('footer', { year: _vm.year }))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }